import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=921f2dca"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('921f2dca')) {
      api.createRecord('921f2dca', component.options)
    } else {
      api.reload('921f2dca', component.options)
    }
    module.hot.accept("./Delete.vue?vue&type=template&id=921f2dca", function () {
      api.rerender('921f2dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Delete.vue"
export default component.exports